<template>
	<div class="d-flex flex-column flex h100">
		<navbar></navbar>
		<div class="app">
			<div id="content" class="app-content box-shadow-3 scroll-x">
				<!-- Optional navbar at top of page -->
				<div class="navbar navbar-light bg-light b-b">
					<a class="flex navbar-breadcrumbs">
						<a class="text-muted" href="/#/classes">Classes</a>
						<i class="far fa-fw fa-angle-right text-muted" />
						<a v-if="classObj && assessment" class="text-muted" :href="`/#/class/${classObj.id}`">{{
							classObj.name
						}}</a>
						<i v-if="classObj && assessment" class="far fa-fw fa-angle-right text-muted" />
						<span v-if="classObj && assessment">{{ assessment.name }}</span>
						<span v-if="!(classObj && assessment)">
							<loading type="inline-header" />
						</span>
					</a>
					<a v-if="classObj" class="btn-nav-topright b-l ml-0" :href="'/#/class/' + classObj.id">
						<div>
							<i class="fas fa-arrow-alt-left fa-fw" />
							Back
						</div>
					</a>
					<a class="btn-nav-topright b-l ml-0" href="/#/landing">
						<div>
							<i class="fas fa-th-large fa-fw" />
							Home
						</div>
					</a>
				</div>

				<div class="content-main">
					<div class="row m-0 align-items-stretch">
						<!-- Assessment details -->
						<div v-if="classObj && assessment" class="col-12 padding pb-0 d-flex flex-column">
							<div class="box d-flex flex-row justify-content-between mb-0">
								<div class="img-square">
									<img :src="contentArea.image_url" />
								</div>
								<div class="flex d-flex flex-column justify-content-between">
									<h6 class="px-3 pt-3 mb-0">
										{{ assessment.name }}
										<span v-if="assessment.ref_id">
											•
											<span class="text-muted text-sm">{{ assessment.ref_id }}</span>
										</span>
									</h6>
									<div class="p-3 text-muted" v-html="assessment.description">}</div>
								</div>

								<div class="px-3 py-3 d-flex flex-column align-self-end align-items-stretch">
									<a
										class="box btn-img p-2 ml-1 assessment-details-btn"
										v-if="item.info_link"
										:href="item.info_link"
										target="_blank"
										v-tippy
										:title="brand.ExternalLinkTooltip"
									></a>
									<div class="d-flex flex-row">
										<a
											class="btn theme text-white mx-1 mt-2"
											:href="`/#/second_score/${assessment.id}/${item.id}`"
											v-tippy
											:title="scoreTooltip"
										>
											<i class="fas fa-check-double" />
										</a>
										<a
											class="btn theme text-white ml-1 mt-2"
											data-toggle="dropdown"
											aria-expanded="false"
											v-tippy
											title="View Resources"
										>
											<i class="fas fa-external-link" />
										</a>
										<div class="dropdown-menu dropdown-menu-right">
											<a
												v-for="(resource, i) in item.resources"
												:key="i"
												class="dropdown-item"
												@click="viewResource(resource)"
											>
												<i class="fas fa-lg fa-file-alt"></i>
												<label class="mb-0">{{ resource.name }}</label>
											</a>
										</div>
									</div>
								</div>
							</div>
						</div>

						<div class="row m-0">
							<!--Reporting-->
							<div v-if="asmtCompChart && workStats && classObj" class="col-12 col-sm-4 padding">
								<div class="flex card box mb-0 h-100 d-flex flex-column">
									<div class="p-3 pb-0">
										<h5 class="_600">
											<span class="float-right d-flex flex-row">
												<a
													class="btn-round-subtle my-1 mx-0"
													@click="openTimeModal"
													v-tippy
													title="Submission Windows"
												>
													<i class="fas fa-clock" />
												</a>
												<a
													v-if="anyScored"
													class="btn-round-subtle my-1 mx-0"
													@click="goToClassReport"
													v-tippy
													title="Class Report"
												>
													<i class="fas fa-chart-bar" />
												</a>
												<a
													v-if="!anyScored"
													class="btn-round-subtle disabled m-1"
													v-tippy
													title="Class Report<br /><small>(No results)</small>"
												>
													<i class="fas fa-chart-bar text-extra-muted" />
												</a>
											</span>
											<span
												>{{ asmtCompTot }} out of
												{{ workStats.length * classObj.deliveries.length }}</span
											>
										</h5>
										<div class="text-muted mb-4">Students with Work</div>
										<div class="py-3 text-center" v-if="asmtCompTot != 0">
											<canvas
												id="chart-bar-2"
												style="max-height: 200px;"
												v-chartjs="asmtCompChart"
											></canvas>
										</div>
										<div class="py-2 text-center" v-if="asmtCompTot == 0">
											<h4 class="text-very-muted">No work</h4>
										</div>
									</div>
									<hr />
									<div
										class="position-relative p-3 pb-4 text-center d-flex flex-column justify-content-center"
									>
										<div class="box-label text-extra-muted">
											<i class="fas fa-check" v-tippy title="First Score" /> vs.
											<i class="fas fa-check-double" v-tippy title="Second Score" />
										</div>
										<table style="width: 100%; table-layout: fixed;">
											<tr style="height: 50%">
												<td class="text-center v-mid">
													<h1
														:class="{
															'text-very-muted':
																!overallTraitAgreement1v2 &&
																overallTraitAgreement1v2 != 0
														}"
													>
														{{ fs.fixedPercent1d(overallTraitAgreement1v2) }}
													</h1>
													<h6 class="text-muted mb-0">Agreement</h6>
													<div class="text-muted">(by trait exact)</div>
												</td>
												<td style="width: 1rem"></td>
												<td class="text-center v-mid">
													<h1
														:class="{
															'text-very-muted':
																!overallTraitAgreementAdj1v2 &&
																overallTraitAgreementAdj1v2 != 0
														}"
													>
														{{ fs.fixedPercent1d(overallTraitAgreementAdj1v2) }}
													</h1>
													<h6 class="text-muted mb-0">Agreement</h6>
													<div class="text-muted">(by trait exact/adj.)</div>
												</td>
											</tr>
											<tr style="height: 50%">
												<td class="text-center v-mid">
													<h1
														:class="{
															'text-very-muted':
																!overallFullAgreement1v2 && overallFullAgreement1v2 != 0
														}"
													>
														{{ fs.fixedPercent1d(overallFullAgreement1v2) }}
													</h1>
													<h6 class="text-muted mb-0">Agreement</h6>
													<div class="text-muted">(full exact)</div>
												</td>
												<td style="width: 1rem"></td>
												<td class="text-center v-mid">
													<h1
														:class="{
															'text-very-muted':
																!overallFullAgreementAdj1v2 &&
																overallFullAgreementAdj1v2 != 0
														}"
													>
														{{ fs.fixedPercent1d(overallFullAgreementAdj1v2) }}
													</h1>
													<h6 class="text-muted mb-0">Agreement</h6>
													<div class="text-muted">(full exact/adj.)</div>
												</td>
											</tr>
										</table>
									</div>
									<hr />
									<div
										class="position-relative p-3 pb-4 text-center d-flex flex-column justify-content-center"
									>
										<div class="box-label text-extra-muted">
											<i class="fas fa-check" v-tippy title="First Score" /> vs.
											<i class="fas fa-shield-check" v-tippy title="Resolution Score" />
										</div>
										<table style="width: 100%; table-layout: fixed;">
											<tr style="height: 50%">
												<td class="text-center v-mid">
													<h1
														:class="{
															'text-very-muted':
																!overallTraitAgreement1v3 &&
																overallTraitAgreement1v3 != 0
														}"
													>
														{{ fs.fixedPercent1d(overallTraitAgreement1v3) }}
													</h1>
													<h6 class="text-muted mb-0">Agreement</h6>
													<div class="text-muted">(by trait exact)</div>
												</td>
												<td style="width: 1rem"></td>
												<td class="text-center v-mid">
													<h1
														:class="{
															'text-very-muted':
																!overallTraitAgreementAdj1v3 &&
																overallTraitAgreementAdj1v3 != 0
														}"
													>
														{{ fs.fixedPercent1d(overallTraitAgreementAdj1v3) }}
													</h1>
													<h6 class="text-muted mb-0">Agreement</h6>
													<div class="text-muted">(by trait exact/adj.)</div>
												</td>
											</tr>
											<tr style="height: 50%">
												<td class="text-center v-mid">
													<h1
														:class="{
															'text-very-muted':
																!overallFullAgreement1v3 && overallFullAgreement1v3 != 0
														}"
													>
														{{ fs.fixedPercent1d(overallFullAgreement1v2) }}
													</h1>
													<h6 class="text-muted mb-0">Agreement</h6>
													<div class="text-muted">(full exact)</div>
												</td>
												<td style="width: 1rem"></td>
												<td class="text-center v-mid">
													<h1
														:class="{
															'text-very-muted':
																!overallFullAgreementAdj1v3 &&
																overallFullAgreementAdj1v3 != 0
														}"
													>
														{{ fs.fixedPercent1d(overallFullAgreementAdj1v2) }}
													</h1>
													<h6 class="text-muted mb-0">Agreement</h6>
													<div class="text-muted">(full exact/adj.)</div>
												</td>
											</tr>
										</table>
									</div>
								</div>
							</div>

							<!-- Students -->
							<div v-if="classObj" class="col-12 col-sm-8 padding pl-0 d-flex flex-column">
								<div class="flex card box mb-0 h-100">
									<table>
										<tr>
											<th class="b-b pl-3 v-bottom" style="width: 20%">
												Students
												<span class="text-muted text-sm">({{ workStats.length }})</span>
											</th>
											<th class="b-b pl-3 v-bottom" style="width: 20%">ID</th>
											<th class="b-b pl-3 v-bottom" style="width: 30%">Report</th>
											<th
												colspan="5"
												class="b-b px-2 text-center"
												v-for="deliv in classObj.deliveries"
												:key="deliv.id"
											>
												<div class="d-flex flex-row align-items-center justify-content-center">
													<a
														class="btn-round-subtle my-1 mx-0"
														v-tippy
														title="Upload Work"
														:href="
															`/#/class/${classObj.id}/assessment/${assessment.id}/delivery/${deliv.id}`
														"
													>
														<i class="fas fa-file-upload fa-lg" />
													</a>
													<a
														class="btn-round-subtle my-1 mx-0"
														v-tippy
														title="Request Work from Students"
														data-toggle="emailModal"
														@click="openEmailModal(deliv)"
													>
														<i class="fas fa-envelope fa-lg" />
													</a>
													<a
														v-if="item.per_class_reliability"
														data-toggle="modal"
														data-target="#reliabilityModal"
														class="btn-round-subtle my-1 mx-0"
														v-tippy
														title="Second Score %"
														@click="editDelivery = deliv"
													>
														<i class="fas fa-percentage fa-lg" />
													</a>
													<a
														class="btn-round-subtle my-1 mx-0"
														v-tippy
														title="Score"
														:href="
															`/#/scoring/${assessment.id}/${item.id}/${classObj.id}/${deliv.id}`
														"
													>
														<i class="fas fa-check fa-lg" />
													</a>
													<a
														v-if="deliv.anyScored"
														class="btn-round-subtle my-1 mx-0"
														v-tippy
														title="Results Report"
														@click="goToReport(deliv)"
													>
														<i class="fas fa-chart-bar fa-lg" />
													</a>
													<a
														v-if="!deliv.anyScored"
														class="btn-round-subtle disabled my-1 mx-0"
														v-tippy
														disabled
														title="Results Report<br /><small>(No results)</small>"
													>
														<i class="fas fa-chart-bar fa-lg text-extra-muted" />
													</a>
												</div>
												<div v-if="deliv.chart" class="position-relative">
													<canvas
														id="chart-bar-2"
														style="max-height: 80px;"
														v-chartjs="deliv.chart"
													></canvas>
													<div
														class="circle-bottom-left text-xxs text-muted"
														v-tippy
														title="Completion"
													>
														<div style="margin-bottom: -4px; margin-left: 2px;">
															<i class="fas fa-badge" />
														</div>
														<div :class="{ 'fit-100-left': deliv.completionPer == '100' }">
															{{ deliv.completionPer }}%
														</div>
													</div>
													<div
														class="circle-bottom-right text-xxs text-muted"
														v-tippy
														title="Agreement"
													>
														<div style="margin-bottom: -4px; margin-left: 2px;">
															<i class="fas fa-check-double" />
														</div>
														<div :class="{ 'fit-100-right': deliv.completionPer == '100' }">
															{{ deliv.agreementPer }}%
														</div>
													</div>
												</div>
												<!-- <div style="border-radius: 65px; height: 80px; width: 80px; padding: 5px; background-color: lightblue; margin: auto;"></div> -->
												<div class="text-center">{{ deliv.name }}</div>
											</th>
										</tr>
										<tr class="student-row" v-for="stat in workStats" :key="stat.student.id">
											<td class="b-b b-r pl-3">
												<i class="fas fa-lg fa-user mr-2"></i>
												<span>{{ stat.student.full_name }}</span>
											</td>
											<td class="b-b b-r pl-3">
												<span>{{ stat.student.ref_id }}</span>
											</td>
											<td class="b-b b-r pl-3">
												<router-link
													:to="{
														name: 'StudentResults',
														params: { classID: classObj.id, studentID: stat.student.id }
													}"
												>
													<a> <i class="pl-2 fa fa-chart-bar fa-lg" /> </a>
												</router-link>
											</td>
											<template v-for="(col, i) in stat.workCols">
												<td
													:key="`cell-1-${i}`"
													class="b-b pl-3 pr-1 text-center nowrap pointer"
													:class="{ [getHighlightClass(col)]: true }"
												>
													<i
														v-if="col.media && col.media.length"
														style="flex: 1;"
														class="pl-0 pr-1 fas fa-file-alt fa-lg"
														v-tippy="{ theme: 'popover' }"
														:title="workTooltip(col.media)"
													/>
													<i
														v-if="!col.media"
														class="pl-0 pr-1 far text-extra-muted fa-file-alt fa-lg"
													/>
												</td>
												<td
													v-if="col.media && col.media.length"
													@click="openScore(col)"
													:key="`cell-2-${i}`"
													class="b-b px-1 text-center nowrap pointer"
												>
													<div :class="{ clickable: col.first_score }">
														<i
															v-if="col.first_score"
															class="material-icons"
															style="font-size: 28px; line-height: 32px;"
															v-tippy="{
																theme: 'popover',
																html: `#s-${stat.student.id}-${i}-first`,
																placement: 'bottom'
															}"
														>
															{{ fs.scoreTypeIcon(1) }}
														</i>
														<div
															v-if="col.first_score"
															class="d-none p-0"
															:id="`s-${stat.student.id}-${i}-first`"
														>
															<Score
																:score="col.first_score"
																:rubric="assessment.rubric"
																:type="1"
															></Score>
														</div>
														<i
															v-if="!col.first_score"
															class="material-icons text-extra-muted"
															style="font-size: 28px; line-height: 32px;"
														>
															{{ fs.scoreTypeIcon(1) }}
														</i>
													</div>
												</td>
												<td
													v-if="col.media && col.media.length"
													@click="openScore(col)"
													:key="`cell-3-${i}`"
													class="b-b px-1 text-center nowrap pointer"
												>
													<div :class="{ clickable: col.second_score }">
														<i
															v-if="col.second_score"
															class="material-icons"
															style="font-size: 28px; line-height: 32px;"
															v-tippy="{
																theme: 'popover',
																html: `#s-${stat.student.id}-${i}-second`,
																placement: 'bottom'
															}"
														>
															{{ fs.scoreTypeIcon(2) }}
														</i>
														<div
															v-if="col.second_score"
															class="d-none p-0"
															:id="`s-${stat.student.id}-${i}-second`"
														>
															<Score
																:score="col.second_score"
																:rubric="assessment.rubric"
																:type="1"
															></Score>
														</div>
														<i
															v-if="
																!col.second_score && col.reliability_score && !col.team
															"
															class="material-icons text-extra-muted"
															style="font-size: 28px; line-height: 32px;"
														>
															{{ fs.scoreTypeIcon(2) }}
														</i>
														<i
															v-if="
																!col.second_score && col.reliability_score && col.team
															"
															class="pl-0 far text-extra-muted fa-hands-helping fa-lg"
															v-tippy
															:title="cstTooltip(col.team.name)"
														/>
													</div>
												</td>
												<td
													v-if="col.media && col.media.length"
													@click="openScore(col)"
													:key="`cell-4-${i}`"
													class="b-b px-1 text-center nowrap pointer"
												>
													<div :class="{ clickable: col.res_score }">
														<i
															v-if="col.res_score"
															class="material-icons"
															style="font-size: 28px; line-height: 32px;"
															v-tippy="{
																theme: 'popover',
																html: `#s-${stat.student.id}-${i}-res`,
																placement: 'bottom'
															}"
														>
															{{ fs.scoreTypeIcon(3) }}
														</i>
														<div
															v-if="col.res_score"
															class="d-none p-0"
															:id="`s-${stat.student.id}-${i}-res`"
														>
															<Score
																:score="col.res_score"
																:rubric="item.rubric"
																:type="1"
															></Score>
														</div>
														<i
															v-if="
																!col.res_score &&
																	col.state != 10 &&
																	col.reliability_score
															"
															class="material-icons text-extra-muted"
															style="font-size: 28px; line-height: 32px;"
														>
															{{ fs.scoreTypeIcon(3) }}
														</i>
													</div>
												</td>
												<td
													v-if="col.media && col.media.length"
													@click="openScore(col)"
													:key="`cell-5-${i}`"
													class="b-b b-r pl-1 pr-3 text-center nowrap pointer"
												>
													<div :class="{ clickable: col.messages_total > 0 }">
														<b
															v-if="col.messages_unread == 0"
															style="line-height: 14px; vertical-align: middle; margin-top: -5px;"
															class="badge badge-pill grey"
															:class="{ 'text-very-muted': col.messages_total == 0 }"
															v-tippy
															title="Comments"
															>{{ col.messages_total }}</b
														>
														<b
															v-if="col.messages_unread > 0"
															style="line-height: 14px; vertical-align: middle; margin-top: -5px;"
															class="badge badge-pill danger"
															v-tippy
															title="Unread Comments"
															>{{ col.messages_unread }}</b
														>
													</div>
												</td>

												<td
													colspan="4"
													v-if="!col.media || !col.media.length"
													:key="`cell-nw-${i}`"
													class="b-b b-r pl-1 pr-3 text-center"
												>
													<span class="text-extra-muted _600">No work</span>
												</td>
											</template>
											<!-- <td style="width: 1px;" class="v-mid b-b px-3">
												<div class="d-flex flex-row">
													<a class="btn-round-subtle mr-0" v-tippy title="Edit Student">
														<i class="fas fa-lg fa-edit" />
													</a>
													<a class="btn-round-subtle mr-0" data-toggle="dropdown" aria-expanded="false">
														<i class="fas fa-lg fa-ellipsis-v" />
													</a>
													<div class="dropdown-menu dropdown-menu-right">
														<a class="dropdown-item">
															<i class="fas fa-trash"></i>
															<label class="mb-0">Delete Student</label>
														</a>
														<a class="dropdown-item">
															<i class="fas fa-chart-bar"></i>
															<label class="mb-0">View Student's Results</label>
														</a>
														<a class="dropdown-item">
															<i class="fas fa-clipboard-check"></i>
															<label class="mb-0">Student Report</label>
														</a>
													</div>
												</div>
											</td>-->
										</tr>
									</table>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="modal" id="emailModal" data-backdrop="static" data-keyboard="false">
			<div class="modal-dialog modal-lg">
				<div v-if="emailDelivery" class="modal-content">
					<div class="modal-header flex-column">
						<h5 class="mb-0">Request Student Work</h5>
						<div v-if="emailDelivery" class="text-muted">{{ emailDelivery.name }}</div>
					</div>
					<div class="modal-body m-3">
						<p class="mb-4 text-md">
							You can send an email to students containing a link to upload work to this assignment.
						</p>
						<div class="scroll-y" style="max-height: calc(100vh - 405px); min-height: 90px;">
							<loading
								v-if="!emailStats"
								type="large"
								class="text-center text-muted border w-100 py-4"
								style="font-size: 4rem;"
							/>
							<table v-if="emailStats" class="p-3 w-100 border">
								<tr>
									<th class="py-1 position-relative" style="width: 1px">
										<table-multiselect
											v-model="selectedIDs"
											:selectAll.sync="selectAll"
											master
											:items="
												ld.map(
													ld.filter(emailStats, s => {
														return s.student.email;
													}),
													'student'
												)
											"
											byField="id"
											:totalRows="
												ld.filter(emailStats, s => {
													return s.student.email;
												}).length
											"
											:numSelected.sync="numSelected"
										></table-multiselect>
									</th>
									<th class="v-mid px-2 py-1" style="width: 20%">
										Students
										<span class="text-muted text-sm">({{ emailStats.length }})</span>
									</th>
									<th class="v-mid px-2 py-1">ID</th>
									<th class="v-mid px-2 py-1">Email Address</th>
									<th class="v-mid px-2 py-1 text-center">Request Status</th>
								</tr>
								<tr
									class="student-row border"
									v-for="stat in emailStats"
									:key="stat.student.id"
									:class="{ 'text-very-muted': !stat.student.email }"
								>
									<td>
										<table-multiselect
											v-if="stat.student.email"
											:value="selectedIDs"
											:selectAll="selectAll"
											:id="stat.student.id"
										></table-multiselect>
									</td>
									<td class="px-2 py-1">
										<i v-if="!stat.student.email" class="fas fa-lg fa-user fa-fw mr-1"></i>
										<template v-if="stat.student.email">
											<i v-if="stat.request.status == 0" class="fas fa-lg fa-user fa-fw mr-1"></i>
											<i
												v-if="stat.request.status == 1"
												class="fas fa-lg fa-envelope-open fa-fw mr-1"
											></i>
											<i
												v-if="stat.request.status == 2"
												class="fas fa-lg fa-file-alt fa-fw mr-1"
											></i>
										</template>
										<span>{{ stat.student.full_name }}</span>
									</td>
									<td class="px-2 py-1">
										<span>{{ stat.student.ref_id }}</span>
									</td>
									<td class="px-2 py-1">
										<span v-if="stat.student.email">{{ stat.student.email }}</span>
										<span v-if="!stat.student.email">(None)</span>
									</td>
									<td class="px-2 py-1 text-center">
										<span v-if="!stat.student.email">Cannot send</span>
										<template v-if="stat.student.email && !stat.hasWork">
											<span v-if="stat.request.status == 0" class="text-muted">Not Sent</span>
											<span v-if="stat.request.status == 1" class="_600 text-primary"
												>Waiting for Work</span
											>
											<span
												v-if="stat.request.status == 2"
												class="_600 text-warning"
												v-tippy
												:title="teacherDeletedTooltip"
											>
												<i class="fas fa-exclamation-triangle" /> Teacher Deleted
											</span>
										</template>
										<template v-if="stat.student.email && stat.hasWork">
											<span v-if="stat.request.status == 0" class="_600 text-success"
												>Teacher Submitted</span
											>
											<span
												v-if="stat.request.status == 1"
												class="_600 text-warning"
												v-tippy
												:title="teacherSubmittedTooltip"
											>
												<i class="fas fa-exclamation-triangle" /> Teacher Submitted
											</span>
											<span v-if="stat.request.status == 2" class="_600 text-success"
												>Submitted</span
											>
										</template>
									</td>
								</tr>
							</table>
						</div>
						<div class="d-flex flex-row mt-3">
							<div class="mr-4" style="width: 33%">
								<label>Submission Window Start</label>
								<config-date
									:disabled="true"
									placeholder="Anytime"
									v-model="emailDelivery.window_start"
								/>
							</div>
							<div class="mr-4" style="width: 33%">
								<label class="flex">Submission Window End</label>
								<config-date
									:disabled="true"
									placeholder="Anytime"
									v-model="emailDelivery.window_end"
								/>
							</div>
							<div class="flex d-flex flex-row align-items-end justify-content-end">
								<div
									v-if="emailDelivery.beforeWindow"
									class="dropdown"
									v-tippy
									title="Submission window hasn't started yet"
								>
									<button class="btn btn-secondary" disabled>Send Emails...</button>
								</div>
								<div
									v-if="emailDelivery.afterWindow"
									class="dropdown"
									v-tippy
									title="Submission window has ended"
								>
									<button class="btn btn-secondary" disabled>Send Emails...</button>
								</div>
								<div v-if="!(emailDelivery.beforeWindow || emailDelivery.afterWindow)" class="dropdown">
									<button
										v-if="!sendingEmails"
										class="btn btn-primary dropdown-toggle"
										data-toggle="dropdown"
										aria-haspopup="true"
										aria-expanded="false"
									>
										<i class="fas fa-envelope fa-fw mr-2" />Send Emails...
									</button>
									<button
										v-if="sendingEmails"
										class="btn btn-primary dropdown-toggle"
										data-toggle="dropdown"
										aria-haspopup="true"
										aria-expanded="false"
										disabled
									>
										<loading type="icon" class="mr-2" />Sending Emails...
									</button>
									<div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
										<a class="dropdown-item" @click="sendEmails('all')">To All Students</a>
										<a class="dropdown-item" @click="sendEmails('unemailed')"
											>To Un-emailed Students</a
										>
										<a class="dropdown-item" @click="sendEmails('selected')"
											>To Selected Students</a
										>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="modal-footer">
						<button class="btn btn-flat theme" data-dismiss="modal">Done</button>
					</div>
				</div>
			</div>
		</div>

		<div class="modal" id="timeModal" data-backdrop="static" data-keyboard="false">
			<div class="modal-dialog" style="max-width: 550px;">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="mb-0">Submission Windows</h5>
					</div>
					<div v-if="classObj" class="modal-body">
						<div class="px-3 py-2">
							<p class="text-md">
								Choose the times when students are allowed to submit work for each assignment
							</p>
							<p class="mb-2 text-muted">
								This applies to student uploads via URL, QR code, or email request
							</p>
						</div>
						<div class="px-2 pb-3">
							<div v-for="deliv in classObj.deliveries" :key="deliv.id" class="card p-2 mt-2">
								<div class="_600 text-theme">{{ deliv.name }}</div>
								<div class="d-flex flex-row">
									<div class="mr-4" style="width: 50%">
										<div class="d-flex flex-row">
											<label class="flex">Submission Window Start</label>
											<button
												v-if="deliv.window_start"
												type="button"
												class="btn btn-subtle-sm float-right"
												style="width: 35px;"
												@click="deliv.window_start = null"
											>
												<i class="fa fa-times"></i>
											</button>
										</div>
										<config-date
											placeholder="Anytime"
											v-model="deliv.window_start"
											defaultTime="6:00 AM"
										/>
									</div>
									<div style="width: 50%">
										<div class="d-flex flex-row">
											<label class="flex">Submission Window End</label>
											<button
												v-if="deliv.window_end"
												type="button"
												class="btn btn-subtle-sm float-right"
												style="width: 35px;"
												@click="deliv.window_end = null"
											>
												<i class="fa fa-times"></i>
											</button>
										</div>
										<config-date
											placeholder="Anytime"
											v-model="deliv.window_end"
											defaultTime="11:59 PM"
										/>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="modal-footer">
						<button class="btn btn-flat btn-primary" data-dismiss="modal" @click="cancelTimeModal">
							Cancel
						</button>
						<button class="btn btn-flat btn-success" @click="saveTimes">Save</button>
					</div>
				</div>
			</div>
		</div>

		<div class="modal" id="reliabilityModal" data-backdrop="static" data-keyboard="false">
			<div class="modal-dialog">
				<div class="modal-content" v-if="editDelivery">
					<div class="modal-header">
						<h5 class="mb-0">Configure Second Score percentage - {{ editDelivery.name }}</h5>
					</div>
					<div class="modal-body">
						<div class="row m-0">
							<small class="form-group col-12 form-text text-muted"
								>Note: Your responses that are marked for Second Scoring will not be recalculated until
								you upload new work.</small
							>

							<div class="form-group col-6 checkbox" v-if="item.allow_teacher_reliability">
								<label
									class="ui-check"
									style="padding-top: 35px;"
									v-tippy="{ theme: 'popover', placement: 'right-start' }"
								>
									<input v-model="editDelivery.use_default" type="checkbox" />
									<i class="dark-white"></i> Use Item Default
								</label>
							</div>
							<div class="form-group col-6 checkbox" v-if="!item.allow_teacher_reliability">
								<small class="form-group col-12 form-text text-muted" style="padding-top: 24px;"
									>You cannot change this setting</small
								>
							</div>
							<div class="form-group col-6">
								<label>Percentage of Second Scores</label>
								<percent-input
									v-if="item.allow_teacher_reliability && !editDelivery.use_default"
									v-model="editDelivery.reliability_percent"
								/>
								<percent-input
									v-if="editDelivery.use_default || !item.allow_teacher_reliability"
									v-model="item.reliability_percent"
									disabled
								/>
							</div>
						</div>
					</div>
					<div class="modal-footer">
						<button class="btn btn-flat" data-dismiss="modal">Cancel</button>
						<button v-show="!deliverySaving" class="btn btn-flat btn-success" @click="saveDelivery">
							Save
						</button>
						<button v-show="deliverySaving" class="btn btn-flat btn-success" disabled>
							Saving...
							<loading type="icon" />
						</button>
					</div>
				</div>
			</div>
		</div>

		<mzfooter></mzfooter>
	</div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.student-row {
	height: 42px;
}
.curved-br {
	border-bottom-right-radius: 0.75rem;
}
progress[value] {
	/* Reset the default appearance */
	-webkit-appearance: none;
	appearance: none;

	width: 250px;
	height: 20px;
}
progress[value]::-webkit-progress-bar {
	background-color: #eee;
	border-radius: 2px;
	box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25) inset;
}
progress[value]::-webkit-progress-value {
	background-image: -webkit-linear-gradient(
			-45deg,
			transparent 33%,
			rgba(0, 0, 0, 0.1) 33%,
			rgba(0, 0, 0, 0.1) 66%,
			transparent 66%
		),
		-webkit-linear-gradient(top, rgba(255, 255, 255, 0.25), rgba(0, 0, 0, 0.25)),
		-webkit-linear-gradient(left, #009688, #00eed6);

	border-radius: 2px;
	background-size: 35px 20px, 100% 100%, 100% 100%;
}
.img-square {
	height: 180px;
	width: 180px;
}
.img-square > img {
	height: 180px;
	width: 180px;
	object-fit: cover;
	object-position: center top;
}
.btn-rounded-subtle {
	opacity: 1;
	transition: background-color 0.25s;
	margin: -2px;
	padding: 2px;
	border-radius: 2rem;
}
.btn-rounded-subtle:hover {
	background-color: rgba(0, 0, 0, 0.1);
}
.fit-row {
	max-width: 315px;
	overflow: hidden;
	text-overflow: ellipsis;
}
.circle-bottom-left {
	position: absolute;
	bottom: 2px;
	left: 12px;
	text-align: left;
}
.circle-bottom-right {
	position: absolute;
	bottom: 2px;
	right: 12px;
	text-align: center;
}
.fit-100-left {
	margin-left: -6px;
}
.fit-100-right {
	margin-right: -6px;
}
.unscored {
	background-image: linear-gradient(to right, rgb(189, 99, 191) 8px, white 8px, white 100%);
}
.reliability {
	background-image: linear-gradient(to right, rgb(73, 104, 231) 8px, white 8px, white 100%);
}
.resolution {
	background-image: linear-gradient(to right, rgb(73, 195, 231) 8px, white 8px, white 100%);
}
.complete {
	background-image: linear-gradient(to right, rgb(34, 182, 110) 8px, white 8px, white 100%);
}
.blank {
	background-image: linear-gradient(to right, rgb(230, 230, 230) 8px, white 8px, white 100%);
}
.colgroup-hover > div:hover {
	background-color: red;
}
.clickable {
	margin-left: -4px;
	margin-right: -4px;
	margin-top: -4px;
	margin-bottom: -4px;
	padding: 4px;
	border-radius: 0.5rem;
	transition: background-color 0.25s;
}
.clickable:hover {
	background-color: rgb(0, 0, 0, 0.1);
}
.box-label {
	position: absolute;
	top: -0.75rem;
	left: 0.75rem;
}
.btn-img {
	margin-bottom: 5px;
	transition: background-color 0.15s ease;
}
.btn-img:hover {
	background-color: rgba(0, 0, 0, 0.1);
}
.btn-img:active {
	background-color: rgba(0, 0, 0, 0.25);
}
.btn-subtle-sm {
	margin-top: 0px;
	margin-bottom: 0px;
	margin-right: 0px;
	opacity: 1;
	transition: background-color 0.25s;
	width: 24px !important;
	height: 24px !important;
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	border-radius: 50%;
	padding: 0.5px 0 0 1px;
	background-color: transparent;
}
</style>

<script>
import SingleScoreDriver from "@/services/ScoringDrivers/SingleScoreDriver";
import ViewingDriver from "@/services/ScoringDrivers/ViewingDriver";
import ReportingService from "@/services/ReportingService";
import ResourceService from "@/services/ResourceService";
import AssessmentService from "@/services/AssessmentService";
import ClassService from "@/services/ClassService";
import TeamService from "@/services/TeamService";
import MessageService from "@/services/MessageService";
import ResponseMediaService from "@/services/ResponseMediaService";
import Notie from "@/services/NotieService";
import draggable from "vuedraggable";
import fs from "@/services/FormatService";
import BB from "bluebird";
import moment from "moment";
import $ from "jquery";
import BrandService from "@/services/BrandService";
var brand = BrandService.getBrand();

import Score from "@/components/Score";
import PercentInput from "@/components/PercentInput";
import ConfigDate from "@/components/ConfigDate";
import TableMultiselect from "@/components/TableMultiselect";

export default {
	name: "ClassAssessment",

	props: ["user"],
	components: {
		draggable,
		Score,
		PercentInput,
		ConfigDate,
		TableMultiselect
	},

	data() {
		return {
			ld: _,
			fs: fs,
			brand: brand,
			assessment: null,
			item: null,
			classObj: null,
			contentArea: null,
			teams: null,
			workStats: [],
			emailStats: null,

			rubric: {},

			score: {},

			completion: null,
			traitAgreement1v2: null,
			fullAgreement1v2: null,
			overallTraitAgreement1v2: null,
			overallTraitAgreementAdj1v2: null,
			overallFullAgreement1v2: null,
			overallFullAgreementAdj1v2: null,
			traitAgreement1v3: null,
			fullAgreement1v3: null,
			overallTraitAgreement1v3: null,
			overallTraitAgreementAdj1v3: null,
			overallFullAgreement1v3: null,
			overallFullAgreementAdj1v3: null,
			asmtCompChart: null,
			asmtCompTot: null,
			d: false,

			emailDelivery: null,
			sendingEmails: false,
			selectedIDs: [],
			selectAll: null,
			numSelected: 0,

			newWork: [],
			droppingFiles: false,

			uploadDelivery: null,
			uploading: false,

			editDelivery: null,
			deliverySaving: false,

			scoreTooltip: `Score<br /><div class="text-muted text-xxs">Other teachers'<br />administrations of<br />this assessment</div class="text-very-muted text-xxs">`,
			teacherDeletedTooltip: `<div>The student submitted work, but it no longer exists on the response.</div><div class="text-muted text-xxs">Either there was an error, or the submission was deleted by a teacher or administrator.</div>`,
			teacherSubmittedTooltip: `<div>An email request was sent to the student, but work already exists on the response.</div><div class="text-muted text-xxs">The student will not be able to upload additional work. If you want to receive the student's submission, you will need to delete the existing work.</div>`
		};
	},

	watch: {
		"editDelivery.id"() {
			if (this.editDelivery.reliability_percent == undefined) {
				this.$set(this.editDelivery, "use_default", true);
			}
		},
		"editDelivery.use_default"(newVal, oldVal) {
			if (oldVal != undefined) {
				if (newVal) {
					delete this.editDelivery.reliability_percent;
				}
			}
		}
	},

	computed: {
		emailableStudents() {
			if (!this.emailStats) {
				return [];
			}

			let students = [];
			_.each(this.emailStats, es => {
				if (es.student.email) {
					students.push(es.student);
				}
			});

			return students;
		},

		unemailedStudents() {
			if (!this.emailStats) {
				return [];
			}

			let students = [];
			_.each(this.emailStats, es => {
				if (es.student.email && es.request.status == 0) {
					students.push(es.student);
				}
			});

			return students;
		},

		selectedStudents() {
			if (!this.emailStats) {
				return [];
			}

			let students = [];
			if (this.selectAll) {
				_.each(this.emailStats, es => {
					if (es.student.email && !this.selectedIDs.includes(es.student.id)) {
						students.push(es.student);
					}
				});
			} else {
				_.each(this.emailStats, es => {
					if (es.student.email && this.selectedIDs.includes(es.student.id)) {
						students.push(es.student);
					}
				});
			}

			return students;
		}
	},

	created() {
		this.loadData();
	},
	methods: {
		loadData() {
			let classID = this.$route.params.classID;
			let asmtID = this.$route.params.asmtID;
			return BB.props({
				assessment: AssessmentService.getClassAssessment(classID, asmtID),
				work: AssessmentService.getClassAssessmentWork(classID, asmtID),
				messages: MessageService.getWorkTableMessageCounts(asmtID, classID),
				completion: ReportingService.getAssessmentCompletion(classID, asmtID),
				agreement: ReportingService.getAssessmentAgreement(classID, asmtID),
				teams: TeamService.listTeams()
			})
				.then(resps => {
					this.assessment = resps.assessment.data.assessment;
					this.item = resps.assessment.data.item;
					this.classObj = resps.assessment.data.class;
					this.contentArea = resps.assessment.data.content_area;
					this.teams = resps.teams.data.teams;

					this.workStats = _.orderBy(
						resps.work.data.stats,
						["student.last_name", "student.first_name"],
						["asc", "asc"]
					);
					_.each(this.workStats, stat => {
						stat.student.newWork = [];
					});
					this.ensureWorkCols(this.classObj, this.workStats);

					this.fillMessageCounts(resps.messages.data);

					this.completion = resps.completion.data;
					this.loadCompletionData(this.completion);

					this.traitAgreement1v2 = resps.agreement.data.trait_stats_1v2;
					this.fullAgreement1v2 = resps.agreement.data.full_stats_1v2;
					this.traitAgreement1v3 = resps.agreement.data.trait_stats_1v3;
					this.fullAgreement1v3 = resps.agreement.data.full_stats_1v3;

					let agreement = 0;
					let adj = 0;
					let total = 0;
					_.each(this.traitAgreement1v2, stat => {
						agreement += stat.irr_exact;
						adj += stat.irr_exact_adj;
						total += stat.irr_total;
					});
					this.overallTraitAgreement1v2 = (100 * agreement) / total;
					this.overallTraitAgreementAdj1v2 = (100 * adj) / total;

					agreement = 0;
					adj = 0;
					total = 0;
					_.each(this.fullAgreement1v2, stat => {
						agreement += stat.irr_full;
						adj += stat.irr_full_adj;
						total += stat.irr_total;
					});
					this.overallFullAgreement1v2 = (100 * agreement) / total;
					this.overallFullAgreementAdj1v2 = (100 * adj) / total;

					agreement = 0;
					adj = 0;
					total = 0;
					_.each(this.traitAgreement1v3, stat => {
						agreement += stat.irr_exact;
						adj += stat.irr_exact_adj;
						total += stat.irr_total;
					});
					this.overallTraitAgreement1v3 = (100 * agreement) / total;
					this.overallTraitAgreementAdj1v3 = (100 * adj) / total;

					agreement = 0;
					adj = 0;
					total = 0;
					_.each(this.fullAgreement1v3, stat => {
						agreement += stat.irr_full;
						adj += stat.irr_full_adj;
						total += stat.irr_total;
					});
					this.overallFullAgreement1v3 = (100 * agreement) / total;
					this.overallFullAgreementAdj1v3 = (100 * adj) / total;

					//Load completion/agreement stats & charts for each delivery
					_.each(this.classObj.deliveries, deliv => {
						let delivStat = _.find(this.completion, {
							delivery_id: deliv.id
						});
						if (delivStat) {
							this.constructDeliveryCompletionChart(deliv, delivStat);
							deliv.completionPer = ((100 * delivStat.com) / delivStat.tot).toFixed(0);
							deliv.agreementPer = ((100 * delivStat.com) / delivStat.tot).toFixed(0);
						}

						let agreeStat = _.find(this.traitAgreement, {
							delivery_id: deliv.id
						});
						if (agreeStat) {
							deliv.agreementPer = ((100 * agreeStat.irr_exact) / agreeStat.irr_total).toFixed(0);
						}

						deliv.anyScored = delivStat && delivStat.rel + delivStat.res + delivStat.com > 0;
					});
				})
				.catch(err => {
					console.log(err);
					Notie.error("Failed to load assessment details", err);
				});
		},

		loadCompletionData(stats) {
			let totUns = 0;
			let totRel = 0;
			let totRes = 0;
			let totCom = 0;
			let totTot = 0;
			_.each(stats, stat => {
				totUns += stat.uns;
				totRel += stat.rel;
				totRes += stat.res;
				totCom += stat.com;
				totTot += stat.tot;
			});
			console.log(totUns, totRel, totRes, totCom, totTot);
			this.asmtCompChart = {
				type: "doughnut",
				data: {
					labels: ["Unscored", "Scored Once", "Resolution", "Complete"],
					datasets: [
						{
							data: [totUns, totRel, totRes, totCom],
							borderWidth: 2,
							borderColor: ["#bd63bf", "#4968e7", "#49c3e7", "#22b66e"],
							backgroundColor: ["#bd63bfaa", "#4968e7aa", "#49c3e7aa", "#22b66eaa"],
							hoverBackgroundColor: ["#bd63bfdd", "#4968e7dd", "#49c3e7dd", "#22b66edd"],
							label: "Completion"
						}
					]
				},
				options: {
					maintainAspectRatio: false,
					legend: {
						position: "right",
						labels: {
							boxWidth: 12
						}
					},
					cutoutPercentage: 70
				}
			};
			this.prettifyPieChart(this.asmtCompChart.data.datasets[0].data);
			this.asmtCompTot = totTot;
			this.anyScored = totRel + totRes + totCom > 0;
		},

		constructDeliveryCompletionChart(delivery, cs) {
			delivery.chart = {
				type: "pie",
				data: {
					labels: ["Unscored", "Scored Once", "Resolution", "Complete"],
					datasets: [
						{
							data: [cs.uns, cs.rel, cs.res, cs.com],
							borderWidth: 2,
							borderColor: ["#bd63bf", "#4968e7", "#49c3e7", "#22b66e"],
							backgroundColor: ["#bd63bfaa", "#4968e7aa", "#49c3e7aa", "#22b66eaa"],
							hoverBackgroundColor: ["#bd63bfdd", "#4968e7dd", "#49c3e7dd", "#22b66edd"],
							label: "Completion"
						}
					]
				},
				options: {
					maintainAspectRatio: false,
					legend: {
						display: false
					}
				}
			};
			this.prettifyPieChart(delivery.chart.data.datasets[0].data);
		},

		ensureWorkCols(classObj, stats) {
			let delivs = _.sortBy(classObj.deliveries, "sequence");
			_.each(stats, stat => {
				let i = 0;
				stat.workCols = [];
				this.$set(stat.workCols, "hovering", false);
				_.each(classObj.deliveries, deliv => {
					let resp = _.find(stat.responses, {
						delivery_id: deliv.id
					});
					if (resp) {
						resp.first_score = _.find(resp.scores, {
							score_type: 1
						});
						resp.second_score = _.find(resp.scores, {
							score_type: 2
						});
						resp.res_score = _.find(resp.scores, { score_type: 3 });

						if (resp.team_id) {
							console.log("HANDLE TEAM", resp.team_id);
							let team = _.find(this.teams, { id: resp.team_id });
							if (team) {
								resp.team = team;
							}
						}

						stat.workCols[i] = resp;
					} else {
						stat.workCols[i] = {
							delivery_id: deliv.id,
							scores: {}
						};
					}
					i++;
				});
			});
		},

		fillMessageCounts(counts) {
			let countMap = {};
			_.each(counts, count => {
				countMap[count.id] = count;
			});

			_.each(this.workStats, stat => {
				_.each(stat.responses, resp => {
					let count = countMap[resp.id];
					if (count) {
						resp.messages_total = count.tot;
						resp.messages_unread = count.unr;
					}
				});
			});
		},

		addNewWork(file) {
			var suggestedName = file.name.split(".");
			if (suggestedName.length > 1) {
				//Pop off the extension if it exists
				suggestedName.pop();
			}
			suggestedName = suggestedName.join("");
			suggestedName = suggestedName.replace(/_/g, " ");

			this.newWork.push({
				name: suggestedName,
				file: file,
				uploading: false
			});

			console.log("___ADD NEW WORK___");
			console.log(file);
		},

		addDropFiles(event) {
			console.log("___FILE ENTER___");
			console.log(event.dataTransfer.files);
			this.droppingFiles = true;
		},

		removeDropFiles(event) {
			console.log("___FILE LEAVE___");
			console.log(event.dataTransfer.files);
			this.droppingFiles = false;
		},

		doDropFiles(event) {
			console.log("___FILE DROP___");
			console.log(event.dataTransfer.files);
			_.each(event.dataTransfer.files, file => {
				this.addNewWork(file);
			});
			this.droppingFiles = false;
		},

		uploadAssessment(delivery) {
			this.uploadDelivery = delivery;
		},

		upload() {
			//Iterate over students
			var classID = this.classObj.id;
			var assessmentID = this.assessment.id;
			var deliveryID = this.uploadDelivery.id;
			var itemID = this.assessment.assessment_item.id;
			var url = `/v3/response_media/`;
			url += `${classID}/${assessmentID}/${deliveryID}/${itemID}/`;

			var requests = [];

			var total = 0;
			this.uploading = true;
			_.each(this.workStats, workStat => {
				if (workStat.student.newWork) {
					_.each(workStat.student.newWork, nw => {
						if (nw) {
							let suggestedName = nw.file.name.split(".");
							if (suggestedName.length > 1) {
								//Pop off the extension if it exists
								suggestedName.pop();
							}
							suggestedName = suggestedName.join("");
							suggestedName = suggestedName.replace(/_/g, " ");

							var uploadURL = url + workStat.student.id;
							let form = new FormData();
							form.set("file", nw.file);
							form.set("name", suggestedName);
							total++;
							requests.push({ url: uploadURL, form: form });
						}
					});
				}
			});

			_.each(requests, r => {
				ResponseMediaService.addMedia(r.url, r.form).then(resp => {
					total--;
					if (total == 0) {
						this.loadData();
						$("#uploadWorkModal").modal("toggle");
						this.uploading = false;
						Notie.success("Uploaded work");
					}
				});
			});
		},

		openScore(response) {
			if (!response.media || response.media.length == 0) {
				console.log("No response to display");
				return;
			}

			let aid = response.assessment_id;
			let iid = response.item_id;
			let cid = response.class_id;
			let did = response.delivery_id;
			let rid = response.id;
			if (response.first_score) {
				console.log("VIEWING THIS DRIVER ",aid, iid, rid)
				ViewingDriver.enter(this, aid, iid, rid);
			} else {
				console.log("VIEWING THIS single ",aid, iid, rid)

				SingleScoreDriver.enter(this, aid, iid, cid, did, rid);
			}
		},

		workTooltip(media) {
			let tooltip = `<div class="px-2 pt-2 _600">Work Uploaded:</div><ul style="margin-top: 0.75rem; padding-left: 1.5rem; padding-right: 0.5rem">`;
			_.each(media, (m, i) => {

				if (m.label) {
					tooltip += `<li>${m.label}</li>`;
				} else {
					tooltip += `<li>File ${i}</li>`;
				}
			});

			return tooltip + `</ul>`;
		},

		getExistingWork(stat, deliv) {
			if (!stat || !deliv) {
				return [];
			}

			let col = _.find(stat.workCols, { delivery_id: deliv.id });
			if (col) {
				return col.media;
			}
		},

		removeNewWork(student, work) {
			student.newWork = _.without(student.newWork, work);
			this.$forceUpdate();
		},

		removeExistingWork(stat, media) {
			ResponseMediaService.removeMedia(stat.workCols[0].id, media.sequence).then(function() {
				stat.workCols[0].media = _.without(stat.workCols[0].media, media);
				var seq = 0;
				_.each(stat.workCols[0].media, m => {
					m.sequence = seq;
					seq++;
				});
			});
			console.log(stat.responses[0].id, media.sequence);
		},

		goToClassReport() {
			this.$router.push(`/class/${this.classObj.id}/assessment/${this.assessment.id}/results`);
		},

		goToReport(delivery) {
			this.$router.push(`/class/${this.classObj.id}/assessment/${this.assessment.id}/results?d=${delivery.id}`);
		},

		viewResource(resource) {
			if (resource.type == 1) {
				console.log("INFOS OF RESOURCE",this.assessment.id, resource.id)
				ResourceService.viewResource(this.assessment.id, resource);
			} else if (resource.type == 2) {
				ResourceService.viewExternalResource(resource.path);
			}
			else if (resource.type == 4) {
				ResourceService.viewExternalResource(resource.path);
			}
		},

		saveDelivery() {
			if (this.editDelivery.use_default) {
				this.editDelivery.reliability_percent = null;
			} else {
				if (!this.editDelivery.reliability_percent) {
					this.editDelivery.reliability_percent = 0;
				}
			}
			let saveDelivery = _.cloneDeep(this.editDelivery);
			delete saveDelivery.chart;
			ClassService.saveDelivery(this.classObj.id, saveDelivery)
				.then(resp => {
					Notie.success("Updated second score percentage");
					$("#reliabilityModal").modal("toggle");
				})
				.catch(err => {
					Notie.error("Failed to update second score percentage", err);
				});
		},

		getHighlightClass(col) {
			switch (col.state) {
				case 1:
					return "unscored";
				case 2:
					return "reliability";
				case 3:
					return "resolution";
				case 10:
					return "complete";
				default:
					return "blank";
			}
		},

		prettifyPieChart(data) {
			let inEnd = true;
			for (let i = data.length - 1; i >= 0; i--) {
				if (data[i] == 0) {
					if (inEnd) {
						data.pop();
					} else {
						data[i] = NaN;
					}
				} else {
					console.log(data[i], i);
					inEnd = false;
				}
			}
		},

		openTimeModal() {
			_.each(this.classObj.deliveries, deliv => {
				deliv.init_window_start = deliv.window_start;
				deliv.init_window_end = deliv.window_end;
			});
			$("#timeModal").modal("show");
		},

		cancelTimeModal() {
			_.each(this.classObj.deliveries, deliv => {
				deliv.window_start = deliv.init_window_start;
				deliv.window_end = deliv.init_window_end;
			});
		},

		openEmailModal(delivery) {
			if (delivery.window_start) {
				delivery.startDate = moment(delivery.window_start);
				delivery.beforeWindow = moment().isBefore(delivery.startDate);
			}
			if (delivery.window_end) {
				delivery.endDate = moment(delivery.window_end);
				delivery.afterWindow = moment().isAfter(delivery.endDate);
			}

			this.emailStats = null;
			this.emailDelivery = delivery;
			$("#emailModal").modal("show");

			let classID = this.$route.params.classID;
			let asmtID = this.$route.params.asmtID;
			AssessmentService.getEmailRequestStats(classID, asmtID, delivery.id)
				.then(r => {
					this.emailStats = r.data;
					this.checkExistingWork(delivery);
				})
				.catch(e => {
					console.log(e);
					Notie.error("Failed to get email request info", e);
				});
		},

		sendEmails(behavior) {
			this.sendingEmails = true;

			//Collect which students to send to
			let studentIDs = [];
			switch (behavior) {
				case "all":
					_.each(this.emailableStudents, s => {
						studentIDs.push(s.id);
					});
					break;
				case "unemailed":
					_.each(this.unemailedStudents, s => {
						studentIDs.push(s.id);
					});
					break;
				case "selected":
					_.each(this.selectedStudents, s => {
						studentIDs.push(s.id);
					});
					break;
			}

			let cid = this.$route.params.classID;
			let aid = this.$route.params.asmtID;
			let did = this.emailDelivery.id;
			AssessmentService.sendEmailRequests(cid, aid, did, studentIDs)
				.then(r => {
					this.sendingEmails = false;
					this.emailStats = r.data;
					this.checkExistingWork(this.emailDelivery);
					Notie.success(`Sent ${studentIDs.length} ${studentIDs.length == 1 ? "email" : "emails"}`);
				})
				.catch(e => {
					this.sendingEmails = false;
					console.log(e);
					Notie.error("Failed to send email", e);
				});
		},

		checkExistingWork(delivery) {
			_.each(this.emailStats, es => {
				let ws = _.find(this.workStats, ws => {
					return ws.student.id == es.student.id;
				});
				if (ws) {
					let resp = _.find(ws.responses, {
						delivery_id: delivery.id
					});
					if (resp) {
						es.hasWork = true;
					}
				}
			});
		},

		saveTimes() {
			let windows = [];
			_.each(this.classObj.deliveries, deliv => {
				windows.push({
					delivery_id: deliv.id,
					window_start: deliv.window_start,
					window_end: deliv.window_end
				});
			});

			ClassService.saveSubmissionWindows(this.classObj.id, windows)
				.then(r => {
					Notie.success("Submission windows saved");
					$("#timeModal").modal("hide");
				})
				.catch(e => {
					console.log(e);
					Notie.error("Failed to save submission windows", e);
				});
		},

		cstTooltip(teamName) {
			return `<div class="text-left"><div class="text-xxs text-muted">Second Score - Collaborative Scoring Team</div><div>${teamName}</div></div>`;
		}
	}
};
</script>





// WEBPACK FOOTER //
// src/vues/Classes/ClassAssessment.vue